export default import.meta.ROLLDOWN_FILE_URL_TEajoE9iH6TNg5Q04itnFA